import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function FetchAllAmazonAlertsService(token,data) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/fetchAllAmazonAlerts`, data, {
     
    headers: {
        'Authorization': token,
      }
    })
    .then(res => {
      notify.NotifySuccess("All Amazon Alerts data fetched successfully. Thank You!");
      return res.data;
    })
    .catch(error => {
      console.log(error);
      notify.NotifyError("An error occurred while All Amazon Alerts data fetching. Please try again later.");
      return false;
    });
  }
  
  export default FetchAllAmazonAlertsService;
  